var SvgIcon = require("app/ui/SvgIcon"),
    kind    = require("enyo/kind");

require("app/ui/IconButton.less");

module.exports = kind(/** @lends  app.ui.IconButton.prototype */ {

    /**
     * @private
     */
    name: "app.ui.IconButton",

    /**
     * @private
     */
    classes: "app-ui-icon-button",

    /**
     * The theme to use for this button.
     *
     * @type  {?string}
     * @public
     */
    theme: null,

    /**
     * The text used as button caption.
     *
     * @type  {?string}
     * @public
     */
    caption: null,

    /**
     * The id used to reference an icon from the icon-sprite.
     *
     * @type  {?string}
     * @public
     */
    icon: null,

    /**
     * Align the icon on the left or the right. Default alignment is on the
     * left.
     *
     * @type     {?string}
     * @default  "left"
     * @public
     */
    iconAlignment: "left",

    /**
     * The text that will display as tooltip and is used by screen readers.
     *
     * @type  {?string}
     * @public
     */
    tooltip: null,

    /**
     * @private
     */
    components: [{
        // By wrapping the contents of the button, we can use flex-box styles to
        // align the icon and caption even if the button itself is a `button`
        // tag.
        name:       "content",
        classes:    "app-ui-icon-button__content",
        components: [{
            name:    "icon",
            kind:    SvgIcon,
            classes: "app-ui-icon-button__icon"
        }, {
            name:    "caption",
            classes: "app-ui-icon-button__caption"
        }]
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".icon",
        to:   ".$.icon.icon"
    }, {
        from: ".caption",
        to:   ".$.caption.content"
    }],

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.themeChanged();
            this.captionChanged();
            this.iconChanged();
            this.tooltipChanged();
            this.iconAlignmentChanged();
        };
    }),

    /**
     * Set theme classes based on current theme.
     *
     * @param  {string}  previousTheme  The previous theme
     * @private
     */
    themeChanged: function(previousTheme) {
        var currentTheme = this.get("theme"),
            baseClass    = "app-ui-icon-button",
            $content     = this.$.content,
            $icon        = this.$.icon,
            $caption     = this.$.caption;

        if (previousTheme && previousTheme !== currentTheme) {
            this.removeClass(baseClass + "--" + previousTheme);
            $content.removeClass(baseClass + "__content--" + previousTheme);
            $icon.removeClass(baseClass + "__icon--" + previousTheme);
            $caption.removeClass(baseClass + "__caption--" + previousTheme);
        }

        if (currentTheme && currentTheme !== previousTheme) {
            this.addClass(baseClass + "--" + currentTheme);
            $content.addClass(baseClass + "__content--" + currentTheme);
            $icon.addClass(baseClass + "__icon--" + currentTheme);
            $caption.addClass(baseClass + "__caption--" + currentTheme);
        }
    },

    /**
     * Set css flag in case of no caption
     *
     * @private
     */
    captionChanged: function() {
        this.addRemoveClass("app-ui-icon-button--no-caption", this.get("caption") === null);
    },

    /**
     * Set css flag in case of no icon
     *
     * @private
     */
    iconChanged: function() {
        this.addRemoveClass("app-ui-icon-button--no-icon", this.get("icon") === null);
    },

    /**
     * Set proper css class for icon alignment.
     *
     * @param  {?string}  previousAlignment  The previous alignment
     * @private
     */
    iconAlignmentChanged: function(previousAlignment) {
        var currentAlignment = this.get("iconAlignment");

        if (currentAlignment !== previousAlignment) {
            this.addRemoveClass("app-ui-icon-button--icon-left", currentAlignment === "left");
            this.addRemoveClass("app-ui-icon-button--icon-right", currentAlignment === "right");
        }
    },

    /**
     * Set css flag in case of no icon
     *
     * @private
     */
    tooltipChanged: function() {
        this.setAttribute("title", this.get("tooltip") || null);
    }

});
